/* sts-cart-reward.js — v6.2 5.1: a claimed loyalty gift in the LlamaCart
   drawer (desktop; a phone opens the cart page, snippets/sts-cart-lines
   .liquid, which draws the same line itself). Loaded from
   snippets/sts-bottom-nav.liquid only while the loyalty program is on, or in
   the staff simulator on a theme that is not the live one.

   The drawer is the app's markup, so nothing is inserted into it: the row of
   a reward line (property _sts_reward, assets/sts-loyalty.js) gets
   data-sts-reward, and the rules below hide its quantity stepper and
   Subscribe & save select (a gift is one unit, bought once) and, when it
   costs $0.00 (or is the simulator's, _sts_preview, off the live theme),
   draw the "Reward · Free" pill under its title, the .sts-bbadge look
   (assets/sts-bridge-cart.css). A pseudo-element, not a .sts-bbadge node:
   assets/sts-bundle.js drops that node from every non-bundle row. A row is
   matched to its cart line by position when every row's variant follows the
   cart's order, else by a variant only one line carries; an ambiguous row is
   left as the app drew it. The class names are the ones
   assets/sts-bridge-cart.css already depends on. */
(function (w, d) {
  'use strict';
  var STS = (w.STS = w.STS || {});
  if (STS.cartReward) return;
  STS.cartReward = true;

  var cart = null;
  var box = null;
  var queued = false;
  var reading = false;
  var live = ((w.Shopify || {}).theme || {}).role === 'main';
  var R = '#lcu-llama-cart [data-sts-reward] ';
  var CSS = R + '.lcu__drawer__input-wrapper,' + R + '.lcu__drawer__item__selling-plan{display:none!important}' +
    '#lcu-llama-cart [data-sts-reward="free"] .lcu__drawer__item-title::after{content:"Reward · Free";display:block;width:-moz-fit-content;width:fit-content;' +
    'margin-top:4px;padding:3px 9px;border-radius:999px;background:var(--sts-type-btn,#2F3572);color:var(--sts-type-on,#fff);font-size:10.5px;font-weight:700;letter-spacing:.06em;line-height:1.3;text-transform:uppercase}';

  function vid(row) {
    var a = row.querySelector('a[href*="variant="]');
    var m = a && /variant=(\d+)/.exec(a.getAttribute('href') || '');
    return m ? m[1] : '';
  }

  function read() {
    reading = true;
    w.fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { reading = false; if (c && c.items) { cart = c; queue(); } })
      .catch(function () { reading = false; });
  }

  function pass() {
    queued = false;
    var el = d.getElementById('lcu-llama-cart');
    if (!el) return;
    if (!cart) {
      /* An empty bag (the header's count) has no line to mark: no request. */
      var n = d.querySelector('[data-cart-count]');
      if (!reading && !(n && n.getAttribute('data-cart-count') === '0')) read();
      return;
    }
    if (!d.getElementById('sts-cart-reward-css')) {
      var s = d.createElement('style');
      s.id = 'sts-cart-reward-css';
      s.textContent = CSS;
      d.head.appendChild(s);
    }
    var items = cart.items;
    var rows = [].slice.call(el.querySelectorAll('.lcu__drawer__item'));
    var inOrder = rows.length === items.length && rows.every(function (r, i) { return vid(r) === String(items[i].variant_id); });
    rows.forEach(function (r, i) {
      var line = inOrder ? items[i] : null;
      if (!line) {
        var v = vid(r);
        var hits = items.filter(function (l) { return String(l.variant_id) === v; });
        line = hits.length === 1 ? hits[0] : null;
      }
      var p = (line && line.properties) || {};
      var want = p._sts_reward ? (line.final_line_price === 0 || (p._sts_preview && !live) ? 'free' : '1') : null;
      if (r.getAttribute('data-sts-reward') === want) return;
      if (want) r.setAttribute('data-sts-reward', want);
      else r.removeAttribute('data-sts-reward');
    });
  }

  function queue() {
    if (queued) return;
    queued = true;
    (w.requestAnimationFrame || setTimeout)(pass);
  }

  /* The app re-renders its rows on every change; childList only, so the
     attribute written above never wakes the observer. */
  function watch() {
    var el = d.getElementById('lcu-llama-cart');
    if (el && el !== box && w.MutationObserver) {
      box = el;
      new MutationObserver(queue).observe(el, { childList: true, subtree: true });
    }
    queue();
  }

  function take(c) {
    if (c && c.items) { cart = c; watch(); } else read();
  }
  ['sts:cart:updated', 'theme:cart:change'].forEach(function (n) {
    d.addEventListener(n, function (e) { take(e.detail && e.detail.cart); });
  });
  d.addEventListener('upsell:cart-updated', function (e) { take(e.detail && e.detail.newCart); });
  d.addEventListener('lcu:smart-cart:updated', function () { read(); });
  w.addEventListener('lcu:cart:toggle', watch, true);
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', watch);
  else watch();
  w.addEventListener('load', watch);
})(window, document);
